import React from 'react';

export function useSearchParams(): [URLSearchParams, (params: Record<string, string>) => void] {
  const [params, setParams] = React.useState(() => new URLSearchParams(window.location.search));

  const updateParams = (newParams: Record<string, string>) => {
    const sp = new URLSearchParams(newParams);
    window.history.pushState({}, '', `${window.location.pathname}?${sp.toString()}`);
    setParams(sp);
  };

  return [params, updateParams];
}

export function useCurrentPath() {
  const [path, setPath] = React.useState(window.location.pathname);

  React.useEffect(() => {
    const handler = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  return path;
}

export function navigate(to: string) {
  window.history.pushState({}, '', to);
  window.dispatchEvent(new PopStateEvent('popstate'));
}